import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import DataTable from "../Components/datatablepublisher";
import { RedirectNotLogin, AlertMessageOut, getSession, UpdateState } from "../Components/function";

class Publisher extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      divisionID: '0001',
      userID : '',
      scriptID: '',
      file: '',
      message: '',
    }

      this.SelectInput = React.createRef();
    }
    
    componentDidMount(){
      RedirectNotLogin();
      UpdateState(this, 'divisionID', this.props?.match?.params?.id);
    }

    componentDidUpdate() {
      RedirectNotLogin();
    }

    componentWillReceiveProps(newProps){
      UpdateState(this, 'divisionID', newProps?.match?.params?.id);
    }
 
  render(){
    return (
        <div className="App AppWrap">
    
    <Header self={this}/>
    

    <div className="App iBG dash-dash-full">
    <div className="containers">
   
    <div className="card-lt-wrap ml0">
    <div className="card-lt breadcrumb">
  <h1><NavLink to="/dashboard">Dashboard</NavLink> <i className="fa fa-chevron-right"></i> <NavLink to="/publisher">Publisher</NavLink> <i className="fa fa-chevron-right"></i> {getSession('division')}</h1>
  </div>
  </div>

  <div className="card-lt-wrap ml0">
    <div className="card-lt">
     
     {AlertMessageOut(this)}

     <DataTable
     route="publisher"
     badge={['', '', '', '', '', '']}
     thclassX={['', '', 'nowrap', 'nowrap', 'nowrap', '']}
     th={
        ['Script ID', 'Geo Target', 'Review 1', 'Review 2', 'Review 3', 'Details']
     }
     td={
        ['scriptID', 'target', 'cmd1', 'cmd2', 'cmd3', 'detail']
    }
    params={this.props?.match?.params}
     cmd="publisher"
     self={this}
     />

    
     </div>

        <Footer classX="dash-footer"/>

    </div>
    
    </div>

    </div>

    </div>
    );
}

}

export default Publisher;